/**
 * Nula collaboration palette — 8 soft chalk pastels aligned with the design language.
 * Used for cursors, selections, and presence indicators in document and canvas editors.
 * Color palette tuned for collaborative presence visibility.
 */
export const COLLAB_COLORS = [
  '#8894A6', // Storm
  '#94B8D4', // Sky
  '#82C4A0', // Mint
  '#D4C878', // Buttercup
  '#D49494', // Rose
  '#A0A0B8', // Pewter
  '#82B8C4', // Teal
  '#C4988C', // Terracotta (extra slot for collaborative presence variety)
] as const;

/**
 * Pick a deterministic palette color from a string (e.g. user ID).
 * Always returns a hex color from COLLAB_COLORS — never arbitrary HSL.
 */
export function collabColorFromId(id: string): string {
  let hash = 0;
  for (let i = 0; i < id.length; i++) {
    hash = ((hash << 5) - hash + id.charCodeAt(i)) | 0;
  }
  const index = ((hash % COLLAB_COLORS.length) + COLLAB_COLORS.length) % COLLAB_COLORS.length;
  return COLLAB_COLORS[index];
}
